export {
  default as roofDeck,
  ReactComponent as RoofDeck,
} from '@assets/icons/features-and-amenities/roof-deck.svg'    
